import dayjs from 'dayjs'
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore'

import {
  BigCalendarFormDataGlobalSlots,
  BigCalendarModalGlobalFormProps,
} from '../../shared/calendar/utils/use-big-calendar-form'
import {
  HouseAvailabilityGlobalInputDto,
  HouseAvailabilityGlobalOrIndividualDto,
  HouseAvailabilityGlobalOrIndividualManyDto,
} from '../../../../../../lib/graphql'
import { convertTimezonedDateToIsoAtMidnight } from '../../../../../../utils/date-helpers'
import {
  divideByFactor,
  multiplyByFactor,
} from '../../../../../../utils/prices'

dayjs.extend(isSameOrBefore)

export const computeHouseAvailabilityGlobalToInputDto = (
  formData: BigCalendarModalGlobalFormProps,
): HouseAvailabilityGlobalOrIndividualDto => {
  const inputDto: HouseAvailabilityGlobalOrIndividualDto = {
    global: computeOneAvailabilityGlobal(formData),
    individual: null,
  }

  return inputDto
}

export const computeHouseAvailabilitiesToInputDto = (
  formData: BigCalendarFormDataGlobalSlots,
): HouseAvailabilityGlobalOrIndividualManyDto => {
  const { start: _start, end: _end } = formData.formValues

  const start = dayjs(_start)
  const end = dayjs(_end)

  const global: HouseAvailabilityGlobalInputDto[] = []

  let current = start

  while (current.isSameOrBefore(end)) {
    global.push({
      ...computeOneAvailabilityGlobal(formData),
      date: current.toDate(),
    })

    current = current.add(1, 'day')
  }
  return { global, individual: null }
}

export const computeHouseAvailabilityGlobalDefaultValues = (
  formData: BigCalendarModalGlobalFormProps,
): BigCalendarModalGlobalFormProps => {
  const { formValues } = formData

  const base = {
    corporateEvening: {
      state: formValues.corporateEvening.state,
      isEnabled: formValues.corporateEvening.isEnabled,
    },
    house: formValues.house,
    houseId: formValues.houseId,
    nightlyTrip: {
      state: formValues.nightlyTrip.state,
      isEnabled: formValues.nightlyTrip.isEnabled,
      options: {
        price: formValues.nightlyTrip.options?.price
          ? divideByFactor(formValues.nightlyTrip.options.price)
          : null,
      },
    },
    studyDay: {
      state: formValues.studyDay.state,
      isEnabled: formValues.studyDay.isEnabled,
      options: {
        price: formValues.studyDay.options?.price
          ? divideByFactor(formValues.studyDay.options.price)
          : null,
      },
    },
  }

  const computedFormData: BigCalendarModalGlobalFormProps =
    formData.type === 'cell'
      ? {
          type: formData.type,
          kind: formData.kind,
          formValues: {
            date: convertTimezonedDateToIsoAtMidnight(formData.formValues.date),
            ...base,
          },
        }
      : {
          type: formData.type,
          kind: formData.kind,
          formValues: {
            start: convertTimezonedDateToIsoAtMidnight(
              formData.formValues.start,
            ),
            end: convertTimezonedDateToIsoAtMidnight(formData.formValues.end),
            ...base,
          },
        }

  return computedFormData
}

const computeOneAvailabilityGlobal = (
  formData: BigCalendarModalGlobalFormProps,
): HouseAvailabilityGlobalInputDto => {
  const { formValues } = formData

  const inputDto: HouseAvailabilityGlobalInputDto = {
    date: convertTimezonedDateToIsoAtMidnight(
      formData.type === 'cell'
        ? formData.formValues.date
        : formData.formValues.start,
    ),
    corporateEvening: {
      isEnabled: formValues.corporateEvening.isEnabled,
    },
    houseId: formValues.houseId,
    nightlyTrip: {
      isEnabled: formValues.nightlyTrip.isEnabled,
      options: formValues.nightlyTrip.isEnabled
        ? {
            price: formValues.nightlyTrip.options?.price
              ? multiplyByFactor(formValues.nightlyTrip.options?.price)
              : null,
          }
        : null,
    },
    studyDay: {
      isEnabled: formValues.studyDay.isEnabled,
      options: formValues.studyDay.isEnabled
        ? {
            price: formValues.studyDay.options?.price
              ? multiplyByFactor(formValues.studyDay.options?.price)
              : null,
          }
        : null,
    },
  }

  return inputDto
}
